import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import {
  Form,
  FormInstance,
  DateSerialized,
  SelectBooleanInput,
  DateInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { EndDate } from '../date';
import SelectTime from '../time';
import Weekday from '../weekday';
import Timezone from '../timezone';
import { CardBlock } from '../../card';
import { GetCurrentTZ } from '../../../../libs/time';
import { useScheduleForm } from '../../../../contexts/form';

interface EpxBFMgmtData {
  method: string;
  language: string;
  start: string;
  end?: string;
  tz: string;
  times: string[];
  days: number[];
  isBorn?: boolean;
}

type EpxBFMgmtDataRaw = DateSerialized<EpxBFMgmtData, 'start' | 'end'>;

export const EpxBFMgmtDefaultData: EpxBFMgmtData = {
  method: 'message',
  language: 'en',
  start: moment().format('YYYY-MM-DD'),
  end: null,
  tz: GetCurrentTZ(),
  times: ['10:00'],
  days: [1, 4],
  isBorn: false
};

const DATE_FORMAT = 'YYYY-MM-DD';
const { DeserializeDate, SerializeDate } = FormInstance;

interface EpxBFMgmtFormProps {
  setForm?: (form: FormInstance<EpxBFMgmtDataRaw>) => void;
  onSubmit?: (data: EpxBFMgmtData) => void;
  isDisabled?: boolean;
}

const EpxBFMgmtForm = ({
  setForm,
  onSubmit,
  isDisabled
}: EpxBFMgmtFormProps): JSX.Element => {
  const { isEditMode } = useScheduleForm();
  const serialize = (data: EpxBFMgmtDataRaw): EpxBFMgmtData => {
    return {
      ...data,
      start: SerializeDate(data.start, DATE_FORMAT),
      end: SerializeDate(data.end, DATE_FORMAT)
    };
  };
  const deserialize = (data: EpxBFMgmtData): EpxBFMgmtDataRaw => {
    return {
      ...data,
      start: DeserializeDate(data.start, DATE_FORMAT),
      end: DeserializeDate(data.end, DATE_FORMAT)
    };
  };
  const defaultData = deserialize(EpxBFMgmtDefaultData);
  const form = new FormInstance<EpxBFMgmtDataRaw, EpxBFMgmtData>(defaultData, {
    serialize,
    deserialize
  });
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit} disabled={isDisabled}>
        {(props) => {
          return (
            <>
              <CardBlock>
                <Row>
                  <Col sm={12}>
                    <DateInput
                      label={props.values.isBorn ? 'Birth Date' : 'Start Date'}
                      name="start"
                      fill
                      disabled={isEditMode}
                    />
                  </Col>
                  <Col sm={12}>
                    <SelectBooleanInput
                      label="Baby Is Born"
                      name="isBorn"
                      trueLabel="Yes"
                      falseLabel="No"
                      fill
                    />
                  </Col>
                  <Col sm={12}>
                    <EndDate label="End Date" name="end" />
                  </Col>
                  <Col sm={12}>
                    <SelectTime label="Message At" name="times[0]" />
                  </Col>
                  <Col sm={12}>
                    <Timezone label="Timezone" name="tz" fill />
                  </Col>
                </Row>
                <Row>
                  <Col sm={24}>
                    <Weekday
                      name="days"
                      numItems={2}
                      abbreviated
                      fill
                      inline
                      large
                    />
                  </Col>
                </Row>
              </CardBlock>
            </>
          );
        }}
      </Form>
    </CardBlock>
  );
};

export default EpxBFMgmtForm;
